import { render, staticRenderFns } from "./GroupPersons.vue?vue&type=template&id=1c240ad8&scoped=true"
import script from "./GroupPersons.vue?vue&type=script&lang=js"
export * from "./GroupPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c240ad8",
  null
  
)

export default component.exports